import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

import { EventType } from 'interfaces';

import { breakpoints } from 'styles/basic';
import { linkWithUnderlineHover } from 'styles/mixins';

import Title from 'components/ui/Title';

interface TypeProps {
  colorType?: EventType;
}

const Wrapper = styled.div`
  svg {
    margin-right: 1rem;
    margin-left: 1rem;
    font-size: 2rem;
    color: #e8be3a;
 }
`;

const StyledYearTitle = styled(Title)`
  && {
    font-family: ${(props) => props.theme.fontFamily.special};
    font-size: 6.5rem;

    @media (min-width: ${breakpoints.portraitTablet}) {
      font-size: 9rem;
    }
  }
`;

const HistoryWrapper = styled.div`
  position: relative;
  padding-top: 15rem;

  &::after {
    content: '';
    position: absolute;
    top: 182px;
    left: calc(50%);
    transform: translateX(-50%);
    width: 43px;
    height: 100%;
    background: ${(props) => props.theme.colorMono.black};
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    padding-top: 5rem;
    &::after {
      top: 145px;
    }
  }
`;

const GuitarNeck = styled.div`
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
  width: 10.5rem;
  height: 19rem;
  span {
    position: absolute;
    display: block;
    background: ${(props) => props.theme.colorMono.black};
    &::before {
      content: '';
      position: absolute;
      display: block;
      background: ${(props) => props.theme.colorMono.black};
    }

    &:nth-of-type(1) {
      left: 54px;
      width: 60px;
      height: 62px;
      border-radius: 50%;
    }
    &:nth-of-type(2) {
      top: 24px;
      left: 34px;
      transform: rotate(16deg);
      width: 44px;
      height: 150px;
    }
    &:nth-of-type(3) {
      top: 52px;
      left: 85px;
      transform: rotate(48deg);
      width: 10px;
      height: 14px;
    }
    &:nth-of-type(4) {
      top: 66px;
      left: 52px;
      transform: rotate(-21deg);
      width: 48px;
      height: 84px;
      border-radius: 0 0 20px;
    }
    &:nth-of-type(5) {
      top: 121px;
      left: 100px;
      transform: rotate(-2deg);
      width: 10px;
      height: 33px;
      border-radius: 50%;
    }
    &:nth-of-type(6) {
      top: 138px;
      left: 22px;
      transform: rotate(-36deg);
      width: 85px;
      height: 37px;
      border-radius: 0 0 0 20px;
    }
    &:nth-of-type(7) {
      top: 143px;
      left: 91px;
      transform: rotate(-18deg);
      width: 14px;
      height: 13px;
      border-radius: 2px;
    }
    &:nth-of-type(8) {
      top: 162px;
      left: 13px;
      transform: rotate(25deg);
      width: 33px;
      height: 19px;
      border-radius: 50%;
    }
    &:nth-of-type(9) {
      top: 170px;
      left: 31px;
      width: 43px;
      height: 21px;
      border-bottom: 2px solid #8e8c8c;
    }
    &:nth-of-type(10) {
      top: 19px;
      left: 33px;
      width: 14px;
      height: 18px;
      border-radius: 50%;
      &::before {
        top: 9px;
        left: 12px;
        transform: rotate(14deg);
        width: 10px;
        height: 5px;
      }
    }
    &:nth-of-type(11) {
      top: 42px;
      left: 27px;
      width: 14px;
      height: 18px;
      border-radius: 50%;
      &::before {
        top: 9px;
        left: 12px;
        transform: rotate(14deg);
        width: 10px;
        height: 5px;
      }
    }
    &:nth-of-type(12) {
      top: 65px;
      left: 21px;
      width: 14px;
      height: 18px;
      border-radius: 50%;
      &::before {
        top: 9px;
        left: 12px;
        transform: rotate(14deg);
        width: 10px;
        height: 5px;
      }
    }
    &:nth-of-type(13) {
      top: 88px;
      left: 14px;
      width: 14px;
      height: 18px;
      border-radius: 50%;
      &::before {
        top: 9px;
        left: 12px;
        transform: rotate(14deg);
        width: 10px;
        height: 5px;
      }
    }
    &:nth-of-type(14) {
      top: 112px;
      left: 7px;
      width: 14px;
      height: 18px;
      border-radius: 50%;
      &::before {
        top: 9px;
        left: 12px;
        transform: rotate(14deg);
        width: 10px;
        height: 5px;
      }
    }
    &:nth-of-type(15) {
      top: 136px;
      left: 1px;
      width: 14px;
      height: 18px;
      border-radius: 50%;
      &::before {
        top: 9px;
        left: 12px;
        transform: rotate(14deg);
        width: 10px;
        height: 5px;
      }
    }
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    top: -45px;
  }
`;

const YearWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled(Title)<TypeProps>`
  && {
    display: flex;
    svg {
      order: -1;
    }
  }
`;

const Arrow = styled.span<TypeProps>`
  position: absolute;
  top: -.6rem;
  right:  -7rem;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 3rem;
  border-top: .1rem solid ${(props) => props.theme.colorMono.white};
  border-bottom: .1rem solid ${(props) => props.theme.colorMono.white};
  &::before,
  &::after {
    content: '';
  }
  &::before {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: ${(props) => props.theme.colorMono.white};

    ${(props) => props.colorType === 'tour' && css`
      background: #0559ff;
    `};
    ${(props) => props.colorType === 'concert' && css`
      background: #00b8ff;
    `};
    ${(props) => (props.colorType === 'album' || props.colorType === 'miniAlbum') && css`
      background: #39bcb8;
    `};
    ${(props) => props.colorType === 'single' && css`
      background: #bc2eab;
    `};
    ${(props) => props.colorType === 'dvd' && css`
      background: #d6463e;
    `};
    ${(props) => props.colorType === 'award' && css`
      background: #e8be3a;
    `};
  }
  &::after {
    position: absolute;
    top: 50%;
    right: calc(100%);
    transform: translateY(-50%);
    width: 2rem;
    height: .1rem;
    background: ${(props) => props.theme.colorMono.black};
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    right: -15rem;

    &::after {
      position: absolute;
      top: 50%;
      right: calc(100% + 2rem);
      width: 7rem;
      height: .2rem;
      background: ${(props) => props.theme.colorMono.black};
    }
  }
`;

const EventBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 30rem;
  margin-bottom: 2rem;

  p {
    margin-bottom: 0;
  }
`;

const YearBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 50%;
  padding-right: 5rem;
  font-size: 1.4rem;
  text-align: right;

  &:not(:first-of-type) {
    margin-top: -10rem;
  }

  &:nth-of-type(2n) {
    align-items: flex-start;
    margin-left: auto;
    padding-right: 0;
    padding-left: 5rem;
    text-align: left;

    ${EventBlock} {
      align-items: flex-start;
    }
    ${Arrow} {
      top: -.6rem;
      left: -7rem;
      &::after {
        left: calc(100%);
      }
    }
    ${StyledTitle} {
      svg {
       order: 0;
      }
    }
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    padding-right: 13rem;

    &:nth-of-type(2n) {
      padding-left: 13rem;

      ${Arrow} {
        top: -.6rem;
        left: -15rem;
        &::after {
          left: calc(100% + 2rem);
        }
      }
    }
  }
`;

const LegendList = styled.ul`
  max-width: 34rem;
  margin: 0;
  font-size: 1.4rem;
  list-style: none;

  @media (min-width: ${breakpoints.portraitTablet}) {
    margin-bottom: -10rem;
  }
`;

const LegendListItem = styled.li<TypeProps>`
  display: flex;
  align-items: flex-start;
  gap: .5rem;
  margin-bottom: .5rem;
  line-height: 1.2;

  &::before {
    content: '';
    display: block;
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    margin-top: .2rem;
    border-radius: 50%;
    background: ${(props) => props.theme.color.gray};

    ${(props) => props.colorType === 'tour' && css`
      background: #0559ff;
    `};
    ${(props) => props.colorType === 'concert' && css`
      background: #00b8ff;
    `};
    ${(props) => (props.colorType === 'album' || props.colorType === 'miniAlbum') && css`
      background: #39bcb8;
    `};
    ${(props) => props.colorType === 'single' && css`
      background: #bc2eab;
    `};
    ${(props) => props.colorType === 'dvd' && css`
      background: #d6463e;
    `};
    ${(props) => props.colorType === 'award' && css`
      background: #e8be3a;
    `};
  }
`;

const StyledDescriptionLink = styled(Link)`
  color: ${(props) => props.theme.mainColors.primary};
  ${(props) => linkWithUnderlineHover('&', 1, props.theme.mainColors.primary)};
`;

const AddDescription = styled.p`
  color: ${(props) => props.theme.color.darkGray};
`;

export {
  Wrapper,
  StyledYearTitle,
  HistoryWrapper,
  GuitarNeck,
  YearWrapper,
  YearBlock,
  EventBlock,
  Arrow,
  StyledTitle,
  LegendList,
  LegendListItem,
  StyledDescriptionLink,
  AddDescription
};
